import $api from "@/frontend/shared/api/axios";
import { refactorIncomingSection } from "../../lib/refactorIncomingSection";
import { TDataRoomRow } from "../../ui/TableBody/TableBody";

export async function getDataroomData({ id }: { id: number }): Promise<TDataRoomRow[]> {
  const response = await $api.get(`/portfolio-companies/${id}/data-room`);
  return response.data.data;
}
